var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ServiceDashboardTutorCardHeaderTutorManager", {
        attrs: { user: _vm.cardData.user, shift: _vm.cardData.shift },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }